import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false);  // 禁止凍結
export const dgpaCalendarSlice = createSlice({
  name: 'dgpaCalendar',
  initialState: null,
  reducers: {
    dgpaCalendarUpdate: (state, action) => {
      localStorage.dgpaCalendar = JSON.stringify(action.payload);
      return action.payload;
    },
  },
});
export const dgpaCalendarSelect = (state) => state.dgpaCalendar;
export const { dgpaCalendarUpdate } = dgpaCalendarSlice.actions;
export default dgpaCalendarSlice.reducer;